// action
import {
    GET_ARTICLE,
    GET_ARTICLE_FAIL,
    GET_ARTICLE_SUCCESS,
    GET_ARTICLE_RESET
} from '../action/getArticleAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    data: {},
    message: ""
}

// eslint-disable-next-line import/no-anonymous-default-export
export default function (state = initialState, action) {
    switch (action.type) {
        case GET_ARTICLE:
            return {
                ...state,
                apiState: "loading"
            }
        case GET_ARTICLE_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case GET_ARTICLE_SUCCESS:
            return {
                ...state,
                apiState: "success",
                data: action.response.data.data.result,
            }
        case GET_ARTICLE_RESET:
            return initialState
        default:
            return state
    }
}